export const DEBOUNCE_VALUE = 600;

export const REACT_QUERY_STALE_TIME = 1000 * 60 * 15; // 15 minutes

export const SNACKBAR_DURATION = 5000;

export const POLLING_INTERVAL = 2000;
